package pl.zar.tikthrow.viewmodel

import kotlinx.serialization.Serializable

@Serializable
enum class ContentType(val label: String, val emoji: String) {
    POST("Post", "✏️"),
    SHORTS("Shorts", "📱"),
    VIDEO("Wideo", "🎬")
}
